import { Component } from '@angular/core';

@Component({
  selector: 'app-te-role-data',
  templateUrl: './te-role-data.component.html',
  styleUrls: ['./te-role-data.component.css']
})
export class TeRoleDataComponent {

}
